import React, { Component } from "react";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import Button from "@mui/material/Button";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import Cards from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import StripeLogo from "../../../assets/img/StripeLogo.png";

const styles = {
  form: {
    maxWidth: "500px",
    margin: "2rem auto",
    padding: "24px",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },

  field: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    marginBottom: "2px",
    marginLeft: "2px",
    fontWeight: "600",
    color: "#4a5568",
    textAlign: "left",
  },
  input: {
    width: "100%",
    padding: "10px",
    border: "1px solid #cbd5e0",
    borderRadius: "6px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  inputBox: {
    border: "1px solid #cbd5e0",
    padding: "10px",
    borderRadius: "6px",
    backgroundColor: "#f7fafc",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },

  error: {
    color: "#e53e3e",
    marginTop: "12px",
  },
  success: {
    color: "#38a169",
    marginTop: "12px",
  },
};

class EventCreditCardForm extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  constructor(props) {
    let action = props.action;
    let eventplan = props.eventplan;
    let subscriptionId = props.subscriptionId;
    let pageId = props.pageId;
    super(props);
    this.state = {
      eventplan: eventplan,
      subscriptionId: subscriptionId,
      pageId: pageId,
      action: action,
      cardName: "",
      cardId: "",
      cardNumber: "",
      expiryDate: "",
      cvvCode: "",
      render: false,
      processing: props.processing,
      error: props.error,
      success: false,
      isCardSelected: false,
      billingDetails: {
        name: "",
      },
      onSuccessPayment: props.onSuccessPayment,
      onUpgradePlan: props.onUpgradePlan,
      onCreateEvent: props.onCreateEvent,
      creditCardList: [],
      creditCard: null,
      isDefault: false,
      open: false,
    };
    if (action === "list") {
      this.getCardList();
    }
  }

  getCardList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/paymentms/getCardList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let creditCardList = output.data.creditCardList;
          for (let i = 0; i < creditCardList.length; i++) {
            const el = creditCardList[i];
            el.month = el.month?.toString().padStart(2, "0");
            el.year = el.year?.toString().slice(-2);
            el.number = el.number?.toString().padStart(16, "0");
          }
          const defaultCard = creditCardList.find((item) => item.isDefault);
          const anyChecked = creditCardList.some((item) => item.isDefault);
          this.setState({
            render: true,
            isCardSelected: anyChecked,
            action: creditCardList.length > 0 ? "list" : "create",
            creditCardList: creditCardList,
            creditCard: defaultCard || null,
          });
        } else {
        }
      }
    );
  }
  handleCardNumberChange(e) {
    let number = Utils.formatCardNumber(e.target.value);
    this.setState({ cardNumber: number });
  }
  handleCardNameChange(e) {
    this.setState({ cardName: e.target.value });
  }

  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  handleExpiryDateChange(e) {
    let digits = e.target.value.replace(/[^0-9]/g, "");
    if (digits.length > 4) digits = digits.slice(0, 4);

    let formatted = digits;
    let month = "",
      year = "";

    if (digits.length > 2) {
      month = digits.slice(0, 2);
      year = digits.slice(2);
      formatted = month + "/" + year;
    }

    this.setState({
      expiryDate: formatted, // in MM/YY
      cardMonth: month,
      cardYear: year,
    });
  }
  handleInputChange(event) {
    const { name, value } = event.target;

    this.setState((prevState) => ({
      billingDetails: {
        ...prevState.billingDetails,
        [name]: value,
      },
    }));
  }

  async onPaymentSuccess(paymentIntent) {
    const postObject = {
      header: this.header,
      plan: { id: this.state.eventplan?.id },
      clientSecret: paymentIntent.client_secret,
      paymentIntentId: paymentIntent.id,
      cardName: this.state.cardName,
    };
    await FetchServerData.callPostService(
      "/paymentms/paymentSuccessful",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // PtsAlert.success(output.message);
        let orderPayment = output.data.orderPayment;
        if (orderPayment.isError) {
          this.setState({
            error: orderPayment.errorText,
            processing: false,
          });
        } else {
          this.state.onSuccessPayment();
        }
      } else {
      }
    });
  }
  async onPaymentFailed(paymentIntent) {
    const postObject = {
      header: this.header,
      plan: { id: this.state.eventplan?.id },
      clientSecret: paymentIntent?.client_secret,
      paymentIntentId: paymentIntent?.id,
    };
    await FetchServerData.callPostService(
      "/paymentms/paymentFailed",
      postObject
    ).then((output) => {
      if (output.status === "FAIL") {
        PtsAlert.error(output.message);
      } else {
      }
    });
  }

  addNewCreditCard = async (event) => {
    event.preventDefault();
    const { stripe, elements } = this.props;
    this.setState({ processing: true, error: null });

    if (!stripe || !elements) {
      this.setState({
        error: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }

    // Step 1
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: { name: this.state.cardName },
    });

    if (error) {
      this.setState({
        error: error.message,
        processing: false,
      });
      return;
    } else {
      // Step 2  Backend call to create client secret
      const postObject = {
        header: this.header,
        paymentMethodId: paymentMethod.id,
        isDefault: this.state.isDefault,
      };
      const resp = await FetchServerData.callPostService(
        "/paymentms/addCard",
        postObject
      );
      if (resp.status === "SUCCESS") {
        this.getCardList();
        this.setState({ open: false, cardName: "" });
      } else {
      }
    }
  };

  handleExistingCreditCard = async (event) => {
    const { stripe, elements } = this.props;
    this.props.onCreateEvent(this.state, stripe, elements);
  };

  createClientSecretWithCard = async (event) => {
    event.preventDefault();
    const { stripe, elements } = this.props;
    this.setState({ processing: true, error: null });

    if (!stripe || !elements) {
      this.setState({
        error: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }
    // Step 2  Backend call to create client secret
    const postObject = {
      header: this.header,
      plan: { id: this.state.eventplan?.id },
      card: { id: this.state.creditCard?.id },
      eventId: this.businessDomainId,
    };
    const resp = await FetchServerData.callPostService(
      "paymentms/createSecretWithCard",
      postObject
    );
    const clientSecret = resp.data.clientSecret;

    if (resp.status === "FAIL") {
      this.setState({
        error: resp.errorCode + resp.message,
        processing: false,
      });

      return;
    } else {
      // Step 3 Confirm the payment with card
      const result = await stripe.confirmCardPayment(clientSecret);

      if (result.error) {
        this.setState({
          error: result.error.message,
          processing: false,
        });
        return;
      }

      if (result && result.paymentIntent) {
        this.onPaymentSuccess(result.paymentIntent);
      }

      this.setState({ processing: false });
    }
  };

  handleCreditCardChange(e, rowData) {
    const selectedItems = this.state.creditCardList.map((item) => ({
      ...item,
      isDefault: item.id === rowData.id,
    }));

    const anyChecked = selectedItems.some((item) => item.isDefault);
    const selectedCard = selectedItems.find((item) => item.isDefault) || null;
    this.setState({
      creditCardList: selectedItems,
      isCardSelected: anyChecked,
      creditCard: selectedCard,
    });
  }

  addNewCreditCardCard() {
    this.setState({
      open: true,
    });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleIDefaultChange(e) {
    this.setState({
      isDefault: e.target.checked,
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div className="row d-flex align-item-stretch">
            <div class="col-md-8 align-self-center" id="CreditCards">
              {this.state.creditCardList?.map((rowData, index) => (
                <>
                  {!rowData.isExpired && (
                    <div
                      className="row d-flex"
                      key={rowData.id || index}
                      onClick={(e) =>
                        this.handleCreditCardChange(e, rowData, index)
                      } // clicking anywhere selects it
                      style={{ cursor: "pointer" }}
                    >
                      <div className="col-md-1 align-self-center">
                        <span className="creditCard-radio">
                          <input
                            style={{ cursor: "pointer", marginTop: "8px" }}
                            type="radio"
                            name="inlineRadioOptions"
                            id={`inlineRadio${index}`} // unique id per radio
                            checked={rowData.isDefault}
                            value={rowData.isDefault}
                            onChange={(e) =>
                              this.handleCreditCardChange(e, rowData, index)
                            }
                            onClick={(e) => e.stopPropagation()} // prevent row click duplicating event when input is directly clicked
                          />
                        </span>
                      </div>
                      <div className="col-md-11">
                        <Cards
                          cvc={rowData.cvc}
                          expiry={`${rowData.month}/${rowData.year}`}
                          focused={rowData.focus}
                          name={rowData.fullName}
                          number={rowData.number}
                        />
                      </div>
                    </div>
                  )}
                </>
              ))}
              <div class="row d-flex mt-2 p-3">
                <div className="col-md-1">
                  <span style={{ width: "10px" }}></span>
                </div>
                <div className="col-md-11 text-start">
                  <div class="row ">
                    <Button
                      id="ptsHollowButton"
                      type="submit"
                      variant="contained"
                      startIcon={<AddIcon style={{ fontWeight: "600" }} />}
                      style={{ width: "290px" }}
                      onClick={this.addNewCreditCardCard.bind(this)}
                    >
                      Add new card
                    </Button>
                  </div>
                  <div class="row mt-2">
                    {this.state.isCardSelected ? (
                      <Button
                        style={{
                          background: "rgb(33, 148, 242)",
                          color: "rgb(255, 255, 255)",
                          borderBottom: "3px solid rgb(99, 98, 98)",
                          borderRadius: "5px",
                          padding: "2px 10px",
                          fontSize: "20px",
                          fontWeight: "700",
                          textTransform: "capitalize",
                          width: "290px",
                        }}
                        type="button"
                        // disabled={this.state.processing}
                        onClick={this.handleExistingCreditCard.bind(this)}
                      >
                        {`Pay $${Utils.formatWithCommas(
                          this.state.eventplan?.price
                        )}`}
                      </Button>
                    ) : (
                      <Button
                        style={{
                          background: "#b6bec8",
                          color: "rgb(255, 255, 255)",
                          borderBottom: "3px solid rgb(99, 98, 98)",
                          borderRadius: "5px",
                          padding: "2px 10px",
                          fontSize: "20px",
                          fontWeight: "700",
                          textTransform: "capitalize",
                          width: "290px",
                        }}
                        type="button"
                        disabled={true}
                      >
                        {`Pay $${Utils.formatWithCommas(
                          this.state.eventplan?.price
                        )}`}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xl"
            className="creditCardDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Add New Card</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                  padding: "0.5em",
                }}
              >
                <div className="row d-flex align-item-stretch justify-content-center">
                  <div class="col-md-12 align-self-center">
                    <form
                      onSubmit={this.addNewCreditCard.bind(this)}
                      style={styles.form}
                    >
                      <div className="row">
                        <div className="col-sm-12">
                          <h3>Add a new credit card.</h3>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <label className="form-label">Name on Card</label>
                          <input
                            name="name"
                            value={this.state.cardName}
                            onChange={this.handleCardNameChange.bind(this)}
                            required
                            style={styles.input}
                            placeholder=""
                          />
                        </div>
                      </div>

                      <div className="row  mt-3">
                        <div className="col-md-12">
                          <label className="form-label">Card Number</label>
                          <div style={styles.inputBox}>
                            <CardNumberElement options={{ placeholder: "" }} />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Expiration Date (MM/YY)
                          </label>
                          <div style={styles.inputBox}>
                            <CardExpiryElement options={{ placeholder: "" }} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">CVV</label>
                          <div style={styles.inputBox}>
                            <CardCvcElement options={{ placeholder: "" }} />
                          </div>
                        </div>
                      </div>

                      <div className="row  mt-3">
                        <div className="col-md-12">
                          <span className="me-3 checkboxSize">
                            <FormControlLabel
                              style={{
                                // color: "#000",
                                // width: "210px",
                                margin: "0",
                                padding: "0",
                                height: "15px",
                              }}
                              control={
                                <Checkbox
                                  variant="outlined"
                                  id="isAsset"
                                  checked={this.state.isDefault}
                                  value={this.state.isDefault}
                                  onChange={this.handleIDefaultChange.bind(
                                    this
                                  )}
                                  style={{
                                    background: "none",
                                    paddingLeft: "0px",
                                  }}
                                />
                              }
                              label={
                                <span className="form-label">
                                  Make Default Card
                                </span>
                              }
                            />
                          </span>
                        </div>
                      </div>
                      <div class="row text-center mt-2 p-3">
                        <Button
                          style={{
                            background: "rgb(33, 148, 242)",
                            color: "rgb(255, 255, 255)",
                            borderBottom: "3px solid rgb(99, 98, 98)",
                            borderRadius: "5px",
                            padding: "2px 10px",
                            fontSize: "20px",
                            fontWeight: "700",
                            textTransform: "capitalize",
                          }}
                          type="submit"
                        // disabled={this.state.processing}
                        >
                          Add Card
                        </Button>
                      </div>
                      {this.state.error && (
                        <div className="row" style={{ color: "#e53e3e" }}>
                          {this.state.error}
                        </div>
                      )}
                      {this.state.success && (
                        <div className="row" style={{ color: "#38a169" }}>
                          Card saved successfully!
                        </div>
                      )}
                      <div className="row">
                        <div className="col-sm-12">
                          <img src={StripeLogo} style={{ width: "75px" }} />
                        </div>
                        <div className="col-sm-12">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Credit card information and payments are securely
                            managed by Stripe.
                          </p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </>
      );
    }
  }
}

export default EventCreditCardForm;
